export enum UpdateFrequency {
  Realtime = 'realtime',
  Daily = 'daily',
  Weekly = 'weekly',
  Never = 'noupdates',
}
